const data = {
	data: [
		{
			total: 5,
			data: [
				{
					markingTeamId: 336,
					currentYear: 2019,
					title: 'Building and Architectural Technology Higher Level',
					markingTeamCode: 'X0211201',
					type: 'MAR',
					emailAddress: 'NextTest@qualifications.gov.scot',
					markingMethodCurrentYear: 'Method',
					contractEndDate: '2020-11-30',
					contractReleaseDate: '2020-10-30',
					displayStatus: 'Ready To Issue',
					templateName: 'AA Test Contract 1416',
					templateId: 1416,
					contractTypeName: 'Building and Architectural Technology Higher Level 336',
					hourlyRate: 0,
					throughputRate: 0,
					throughputRateConfirmed: null,
					scriptFee: 0,
					trainingFee: 0,
					sessionRateCurrentYear: 0,
					sessionFeeText: '',
					scriptDeliveryDate: '2010-06-01',
					scriptReturnDate: '2010-06-02',
					eMarkingEndDate: null,
					eMarkingStartDate: null,
					minRange: 5,
					maxRange: 10
				},
				{
					markingTeamId: 1806,
					currentYear: 2019,
					title: 'Marking Team',
					markingTeamCode: 'X1001203',
					type: 'MAR',
					emailAddress: '',
					markingMethodCurrentYear: '',
					contractEndDate: null,
					contractReleaseDate: '2020-05-27',
					displayStatus: 'Issued',
					templateName: 'PHD 1197',
					templateId: 1197,
					contractTypeName: ' Central Marking',
					hourlyRate: 0,
					throughputRate: 0.01,
					throughputRateConfirmed: 'IsNotConfirmed',
					scriptFee: 0,
					trainingFee: 0,
					sessionRateCurrentYear: 0,
					sessionFeeText: '',
					scriptDeliveryDate: null,
					scriptReturnDate: null,
					eMarkingEndDate: null,
					eMarkingStartDate: null,
					minRange: 125,
					maxRange: 175
				},
				{
					markingTeamId: 346,
					currentYear: 2019,
					title: 'Construction Higher Level',
					markingTeamCode: 'X0191201',
					type: 'CMK',
					emailAddress: 'QATest@qa.com',
					markingMethodCurrentYear: 'TestQA',
					contractEndDate: '2020-10-29',
					contractReleaseDate: '2020-10-20',
					displayStatus: 'Issued',
					templateName: 'AA Test Contract 1416',
					templateId: 1416,
					contractTypeName: 'Construction Higher Level 346',
					hourlyRate: 0,
					throughputRate: 0,
					throughputRateConfirmed: null,
					scriptFee: 0,
					trainingFee: 0,
					sessionRateCurrentYear: 0,
					sessionFeeText: '',
					scriptDeliveryDate: '2010-06-01',
					scriptReturnDate: '2010-06-02',
					eMarkingEndDate: '2021-03-30',
					eMarkingStartDate: '2021-02-28',
					minRange: 5,
					maxRange: 10
				},
				{
					markingTeamId: 353,
					currentYear: 2019,
					title: 'Electronics Higher Level',
					markingTeamCode: 'X0271201',
					type: 'CMK',
					emailAddress: '',
					markingMethodCurrentYear: '',
					contractEndDate: null,
					contractReleaseDate: '2020-09-23',
					displayStatus: 'Issued',
					templateName: '',
					templateId: 0,
					contractTypeName: 'Electronics Higher Level 353',
					hourlyRate: 0,
					throughputRate: 0,
					throughputRateConfirmed: null,
					scriptFee: 0,
					trainingFee: 0,
					sessionRateCurrentYear: 0,
					sessionFeeText: '',
					scriptDeliveryDate: null,
					scriptReturnDate: null,
					eMarkingEndDate: null,
					eMarkingStartDate: null,
					minRange: 5,
					maxRange: 10
				},
				{
					markingTeamId: 394,
					currentYear: 2019,
					title: 'Mechanical Engineering Higher Level',
					markingTeamCode: 'X0311201',
					type: 'CMK',
					emailAddress: '',
					markingMethodCurrentYear: 'QA Test',
					contractEndDate: '2020-12-31',
					contractReleaseDate: '2020-11-10',
					displayStatus: 'Issued',
					templateName: 'Template Contract Half yearly 1440',
					templateId: 1440,
					contractTypeName: 'Mechanical Engineering Higher Level 394',
					hourlyRate: 0,
					throughputRate: 0,
					throughputRateConfirmed: null,
					scriptFee: 0,
					trainingFee: 0,
					sessionRateCurrentYear: 0,
					sessionFeeText: '',
					scriptDeliveryDate: null,
					scriptReturnDate: null,
					eMarkingEndDate: null,
					eMarkingStartDate: null,
					minRange: 5,
					maxRange: 10
				}
			],
			errors: []
		}
	],
	errors: []
};

export { data };
